import { LoyaltyFeedCardType } from '@fgb/core';
import { LoyaltyFeedVouchersComponent } from './loyalty-feed-item/loyalty-feed-items/loyalty-feed-voucher/loyalty-feed-vouchers.component';
import { LoyaltyFeedGamesComponent } from './loyalty-feed-item/loyalty-feed-items/loyalty-feed-games/loyalty-feed-games.component';

/* ================================
 * Loyalty Feed Component Maps
 * ================================ */

export const loyatlyFeedComponentMap: Partial<Record<LoyaltyFeedCardType, any>> = {
  [LoyaltyFeedCardType.VoucherCode]: LoyaltyFeedVouchersComponent,
  [LoyaltyFeedCardType.Trivia]: LoyaltyFeedGamesComponent,
  [LoyaltyFeedCardType.Predictor]: LoyaltyFeedGamesComponent,
};
